import axios from "axios";

export const getPermissions = async (targetUser) => {
  try {
    const brear = localStorage.getItem("token");
    const lang = localStorage.getItem("i18nextLng");
    const { data } = await axios.get(
      "/v1/admin/permissions",

      {
        params: {
          guard_name: targetUser,
        },

        headers: {
          Authorization: "Bearer " + `${brear}`,
          app_key: "3D3AhWezABN8DRoPO0VEtP6nq4iDBhKm35E7FlDj",
          lang: lang,
        },
      }
    );
    return data;
  } catch (error) {
    throw error;
  }
};
